<ng-container
  ><ca-clickable-link
    [innerHtml]="
      'QualityManagement::EvaluationObjectionEvaluatorToastrAndNotificationMessage'
        | abpLocalization
    "
    (linkClicked)="onLinkClicked()">
  </ca-clickable-link>
</ng-container>
